export enum InvoiceSplitType {
  ByShift = "ByShift",
  ByDate = "ByDate"
}

export enum InvoiceMonth {
  Full = "Full",
  FirstMonth = "FirstMonth",
  SecondMonth = "SecondMonth"
}

export enum BookingWeekDocumentTypes {
  UncertifiedTimeReport = "UncertifiedTimeReport",
  CertifiedTimeReport = "CertifiedTimeReport",
  ExpensesReceipts = "ExpensesReceipts",
  InvoiceDocs = "InvoiceDocs",
  SalaryBasis = "SalaryBasis",
  BenefitTaxation = "BenefitTaxation",
  TravelConfirmation = "TravelConfirmation",
  AccommodationConfirmations = "AccommodationConfirmations",
  AccommodationTravelInvoices = "AccommodationTravelInvoices",
  AccTravelConfirmationsWithOutBooking = "AccTravelConfirmationsWithOutBooking",
  SubcontractorInvoices = "SubcontractorInvoices",
  StandingCertificateFromCustomer = "StandingCertificateFromCustomer",
  SickPayBasis = "SickPayBasis",
  CreditUnderSupplierInvoice = "CreditUnderSupplierInvoice",
  Other = "Other",
  CallResponse = "CallResponse",
  TimeReport = "TimeReport",
  InvoiceForm = "InvoiceForm",
  PayForm = "PayForm",
  SickPayForm = "SickPayForm",
  SubcontractorPayForm = "SubcontractorPayForm"
}

export enum BookingWeekConsultantDocumentWithOutBookingType {
  AccTravelConfirmationsWithOutBooking = "AccTravelConfirmationsWithOutBooking",
  CallResponse = "CallResponse",
  RentalAdviceAgreement = "RentalAdviceAgreement",
  AccommodationInvoices = "AccommodationInvoices",
  Receipts = "Receipts",
  OtherBookingWeekDocWithOutBookingType = "OtherBookingWeekDocWithOutBookingType",
  CreditUnderSupplierInvoice = "CreditUnderSupplierInvoice",
  Canceled = "Canceled",
  BookingConfirmationToCustomer = "BookingConfirmationToCustomer"
}

export enum BookingContractVariantType {
  Consultant = "Consultant",
  ConsultantBookingConfirmation = "ConsultantBookingConfirmation",
  Customer = "Customer",
  CustomerSubversion = "CustomerSubversion"
}

export enum BookingCSVReportType {
  Bookings = "Bookings",
  OpenPosts = "OpenPosts",
  OpenHalfOpenRecords = "OpenHalfOpenRecords",
  HalfOpenRecords = "HalfOpenRecords",
  Continuity = "Continuity",
  NationalProcurementStatistics = "NationalProcurementStatistics",
  SAHLRStatus = "SAHLRStatus",
  ProfitabilityPerConsultant = "ProfitabilityPerConsultant",
  ProjectReconciliation = "ProjectReconciliation",
  ClosedBookingWeeks = "ClosedBookingWeeks"
}
